import { render } from "./setOauth.vue?vue&type=template&id=23784dfd"
import script from "./setOauth.vue?vue&type=script&lang=js"
export * from "./setOauth.vue?vue&type=script&lang=js"

import "./setOauth.vue?vue&type=style&index=0&id=23784dfd&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__